module.exports = __webpack_public_path__ + "static/media/02C.c0b16b2a.png";